import React from "react";
import { connect } from "react-redux";
import { Text } from "react-internationalization";
//import Footer1 from "../Utils/GenericUI/Footer1";
//import MenuIcon from "@material-ui/icons/Menu";
import history from "../Utils/History";
//import PlanCard from "./PlanCard";
//import { setFormData } from "../Redux/Actions/webAppActions";

const PlanNameDetails = ({ data, ...props }) => {
  //TO-DO STYLING OF THE ENTRIES
  return (
    <div class="headers container-planDetail fit-content">
      {data ? (
        <div>
          {" "}
          <div class="detail-card-header">
            <div class="plan-name large">
              <h5
                class={
                  props.plandetails?.length === 3
                    ? "plan-name-title details-title-mobile-font"
                    : "plan-name-title"
                }
              >
                {data.name}
              </h5>
              <div class="carrier-and-rating">
                <span aria-label="Plan too new to be measured">
                  <div class="rating">
                    <h6 class="rating-description">{data.ratingComment}</h6>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="primary-dollars">
            <div class="primary">
              <p><Text id="plan.monthlyp"/> {data.totalMonthlyPremium}</p>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    // cardDetails: state.webApp.planCardData,
    plandetails: state.webApp.plandetails,
  };
};
const mapDispatchToProps = {
  //   setFormData
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanNameDetails);
